import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { HERO_IMAGE } from '../data/config';
const EASE = [0.22, 1, 0.36, 1] as const;
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 px-5 pb-16 pt-14 sm:px-8 sm:pb-20 sm:pt-20" data-id="element-191" data-mp="9k0f38zo2hq6">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[-20rem] h-[38rem] w-[38rem] -translate-x-1/2 rounded-full bg-accent/20 blur-[150px]" data-id="element-192" data-mp="4mrt0xbedtjn" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative mx-auto w-full max-w-4xl text-center" data-id="element-193" data-mp="xa4e131wttau">
        <p className="flex items-center justify-center gap-4 text-[11px] font-bold uppercase tracking-[0.26em] text-accent-soft sm:text-xs" data-id="element-194" data-mp="nboov5mg0u3z">
          <span aria-hidden="true" className="hidden h-px w-10 bg-accent/50 sm:block" data-id="element-195" data-mp="382ffjpbzl6fg" />
          La guía completa para usuarios de iPhone
          <span aria-hidden="true" className="hidden h-px w-10 bg-accent/50 sm:block" data-id="element-196" data-mp="3j9kazboofhg4" />
        </p>
        <h1 className="mt-6 text-[2.1rem] font-extrabold uppercase leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-[4.2rem]" data-id="element-197" data-mp="3o6khfnpfum7r">
          Dominá tu iPhone
          <span className="mt-1 block text-accent-soft" data-id="element-198" data-mp="3e961rqbca1gi">de una vez por todas</span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-199" data-mp="30iazwxz9ckmf">
          El método paso a paso que convierte tu iPhone de <span className="text-white" data-id="element-200" data-mp="359j6znd47twf">“solo lo básico”</span> a{' '}
          <span className="text-white" data-id="element-201" data-mp="2qkda461r2frp">dominarlo de verdad</span>: funciones ocultas, batería, seguridad, organización y
          cámara, aunque no sepas nada de tecnología.
        </p>
      </motion.div>
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.08,
      ease: EASE
    }} className="relative mx-auto mt-12 w-full max-w-2xl" data-id="element-202" data-mp="2hix03zeukfo0">
        <span className="absolute -top-3 right-4 z-10 rounded-full bg-accent px-4 py-2 text-[11px] font-bold uppercase tracking-wide text-white shadow-[0_8px_30px_-10px_rgba(10,132,255,0.9)]" data-id="element-203" data-mp="s3mavvwi5mv7">
          1 libro + 5 bonos
        </span>
        <img src={HERO_IMAGE} alt="Diccionario Apple: todo Apple en un solo lugar, con explicaciones claras, búsqueda rápida, funciones esenciales y para todos los niveles" className="w-full rounded-3xl border border-white/10 object-cover" data-id="element-204" data-mp="dd5cklf5zd2j" />
      </motion.div>
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.16,
      ease: EASE
    }} className="relative mx-auto mt-10 w-full max-w-2xl" data-id="element-205" data-mp="112pwb6j56ecv">
        <CTAButton className="items-center" data-id="element-206" data-mp="3lt774vhctzwd" />
      </motion.div>
    </header>;
}